define(function(require) {

    var red = "#d30202",
        blue = "#00358c",
        green = "#009900";

    return {
        LEGENDS : {
            GRID_1 : [
                {COLOR : green, SELECTOR : "#MethodologieAnim_gridContainer_1 .MethodologieAnim_cell:not(.MethodologieAnim_unoccupied)"}
            ],
            GRID_2 : [
                {COLOR : red, SELECTOR : "#MethodologieAnim_gridContainer_2 .MethodologieAnim_cell.event1:not(MethodologieAnim_unoccupied)"},
                {COLOR : blue, SELECTOR : "#MethodologieAnim_gridContainer_2 .MethodologieAnim_cell.event2:not(MethodologieAnim_unoccupied)"}
            ]
        },
        YEARS : [
            {
                ID : "year_0",
                TITLE : "30 septembre 2010 : Début de l'année 1",
                START_COUNT : 100,
            }, {
                ID : "year_1",
                TITLE : "Année 1 : Durant l'année scolaire <strong>2010-2011</strong>",
                START_COUNT : 100,
                END_TEXT : "<strong>98 élèves</strong> sont toujours présents dans la cohorte",
                EVENTS : [
                    {CLASS : "event1", COUNT : 2, COLOR : red, TEXT : "On estime que <strong>2 élèves</strong> sont sortis pour cause d'immigration ou décès"},
                    {CLASS : "event2", COUNT : 0, COLOR : blue, TEXT : "Aucun élève n'a diplomé ou qualifié lors de cette année"},
                ]
            }, {
                ID : "year_2",
                TITLE : "Année 2 : Durant l'année scolaire <strong>2011-2012</strong>",
                START_COUNT : 98,
                END_TEXT : "<strong>96 élèves</strong> sont toujours présents dans la cohorte",
                EVENTS : [
                    {CLASS : "event1", COUNT : 2, COLOR : red, TEXT : "On estime que <strong>2 élèves</strong> sont sortis pour cause d'immigration ou décès"},
                    {CLASS : "event2", COUNT : 0, COLOR : blue, TEXT : "Aucun élève n'a diplomé ou qualifié lors de cette année"}
                ]
            }, {
                ID : "year_3",
                TITLE : "Année 3 : Durant l'année scolaire <strong>2012-2013</strong>",
                START_COUNT : 96,
                END_TEXT : "<strong>93 élèves</strong> sont toujours présents dans la cohorte",
                EVENTS : [
                    {CLASS : "event1", COUNT : 3, COLOR : red, TEXT : "On estime que <strong>3 élèves</strong> sont sortis pour cause d'immigration ou décès"},
                    {CLASS : "event2", COUNT : 0, COLOR : blue, TEXT : "Aucun élève n'a diplomé ou qualifié lors de cette année"}
                ]
            }, {
                ID : "year_4",
                TITLE : "Année 4 : Durant l'année scolaire <strong>2013-2014</strong>",
                START_COUNT : 93,
                END_TEXT : "<strong>87 élèves</strong> sont toujours présents dans la cohorte",
                EVENTS : [
                    {CLASS : "event1", COUNT : 1, COLOR : red, TEXT : "On estime que <strong>1 élève</strong> est sortie pour cause d'immigration ou décès"},
                    {CLASS : "event2", COUNT : 5, COLOR : blue, TEXT : "<strong>5 élèves</strong> ont diplomé ou qualifié lors de cette année"},
                ]
            }, {
                ID : "year_5",
                TITLE : "Année 5 : Durant l'année scolaire <strong>2014-2015</strong>",
                START_COUNT : 87,
                END_TEXT : "<strong>32 élèves</strong> sont toujours présents dans la cohorte",
                EQUATION_TITLE : "Taux de diplomation et qualification après 5 ans",
                EQUATION : "\\Large{\\frac{\\color{" + blue + "}{58}}{(\\color{" + blue + "}{58}+\\color{" + green + "}{32})}} \\large{\\mathbf{X} 100 = 64,4\\%}",
                EVENTS : [
                    {CLASS : "event1", COUNT : 2, COLOR : red, TEXT : "On estime que <strong>2 élèves</strong> sont sortis pour cause d'immigration ou décès"},
                    {CLASS : "event2", COUNT : 53, COLOR : blue, TEXT : "<strong>53 élèves</strong> ont diplomé ou qualifié lors de cette année"}
                ]
            }, {
                ID : "year_6",
                TITLE : "Année 6 : Durant l'année scolaire <strong>2015-2016</strong>",
                START_COUNT : 32,
                END_TEXT: "<strong>22 élèves</strong> sont toujours présents dans la cohorte",
                EQUATION_TITLE : "Taux de diplomation et qualification après 6 ans",
                EQUATION : "\\Large{\\frac{\\color{" + blue + "}{67}}{(\\color{" + blue + "}{67}+\\color{" + green + "}{22})}} \\large{\\mathbf{X} 100 = 75,3\\%}",
                EVENTS : [
                    {CLASS : "event1", COUNT : 1, COLOR : red, TEXT : "On estime que <strong>1 élève</strong> est sortie pour cause d'immigration ou décès"},
                    {CLASS : "event2", COUNT : 9, COLOR : blue, TEXT : "<strong>9 élèves</strong> ont diplomé ou qualifié lors de cette année"}
                ]
            }, {
                ID : "year_7",
                TITLE : "Année 7 : Durant l'année scolaire <strong>2016-2017</strong>",
                START_COUNT : 22,
                END_TEXT : "<strong>15 élèves</strong> sont toujours présents dans la cohorte",
                EQUATION_TITLE : "Taux de diplomation et qualification après 7 ans",
                EQUATION : "\\Large{\\frac{\\color{" + blue + "}{73}}{(\\color{" + blue + "}{73}+\\color{" + green + "}{15})}} \\large{\\mathbf{X} 100 = 83,0\\%}",
                EVENTS : [
                    {CLASS : "event1", COUNT : 1, COLOR : red, TEXT : "On estime que <strong>1 élève</strong> est sortie pour cause d'immigration ou décès"},
                    {CLASS : "event2", COUNT : 6, COLOR : blue, TEXT : "<strong>6 élèves</strong> ont diplomé ou qualifié lors de cette année"}
                ]
            }
        ]
    };
});
